import { render } from "./CrudUsercosts.vue?vue&type=template&id=09a6c892&scoped=true"
import script from "./CrudUsercosts.vue?vue&type=script&lang=js"
export * from "./CrudUsercosts.vue?vue&type=script&lang=js"

import "./CrudUsercosts.vue?vue&type=style&index=0&id=09a6c892&lang=css"
import "./CrudUsercosts.vue?vue&type=style&index=1&id=09a6c892&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a6c892"]])

export default __exports__